import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  IconButton,
  InputBase,
  Stack,
  styled,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useWeb3React } from "@web3-react/core";
import { tokens } from "../../theme";
import FilterBox from "./components/FilterBox";
import TableView from "./components/AssetTableView";
import ProfileLayout from "../global/ProfileLayout";
import {
  LAYOUT_TYPES,
  ON_LEND,
  SERVER_BASE_URL,
  SERVER_BASE_URL_PROD,
} from "../../constants";
import {
  activeTab,
  addNft,
  galleryView,
  galleryViewActive,
  tableView,
  tableViewActive,
  addIcon,
  dummyScholarCover,
  dummyScholarProfile,
  searchIcon,
} from "../../assets";
import { myNFTs } from "../../data/dummyNfts";
import { NftCard } from "../../components/NftCard";
import { AssetDetails } from "./components/AssetDetails";
import { scholarsList } from "../../data/dummyScholars";
import { ScholarCard } from "./components/ScholarCard";
import ScholarTableView from "./components/ScholarTableView";
import { ScholarDetails } from "./components/ScholarDetails";
import CustomModal from "../../components/CustomModal";
import { AddScholarForm } from "./components/AddScholarForm";
import { useFormik } from "formik";
import { getSigAndKey } from "../../contract";
import { useAPIActions, useUIActions } from "../../hooks/useActions";
import fetchApi from "../../utils/fetch";
import { useTypedSelector } from "../../hooks/useTypedSelector";
import FinalPreview from "../profile/components/FinalPreview";
import { SelectedNftStep } from "../profile/components/SelectedNftStep";

const Profile = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { account } = useWeb3React();
  const downXl = useMediaQuery(theme.breakpoints.down("xl"));
  const downMd = useMediaQuery(theme.breakpoints.down("md"));

  const [collapsed, setCollapsed] = useState(false);
  const [view, setView] = useState("gallery");
  const [currView, setCurrView] = useState("scholar-details");
  const [open, setOpen] = useState(false);
  const [step, setStep] = useState(0);

  const { connectedAccount, scholars } = useTypedSelector(
    (state) => state.apiReducer
  );

  const [scholarsToRender, setScholarsToRender] = useState(scholars);

  const [searchVar, setSearchVar] = useState("");
  const [searchShow, setSearchShow] = useState(false);
  const [filtered, setFiltered] = useState([]);

  useEffect(() => {
    setScholarsToRender(scholars);
  }, [scholars]);

  const { setSnackbar, setLoading } = useUIActions();
  const { addScholar } = useAPIActions();

  const formik = useFormik({
    initialValues: {
      scholarName: "",
      scholarAddress: "",
      // guildSplit: "",
    },
    onSubmit: async (values) => {
      console.log("values", values);
      const allExistedNames = scholarsToRender.map((scholar) =>
        scholar.scholarName.toLowerCase()
      );
      const allExistedAddress = scholarsToRender.map((scholar) =>
        scholar.scholarAddress.toLowerCase()
      );
      if (allExistedNames.includes(values.scholarName.toLowerCase())) {
        setSnackbar({
          open: true,
          severity: "info",
          message: "Scholar Name Already Exist!",
        });
        setLoading(false);
        return;
      }

      if (allExistedAddress.includes(values.scholarAddress.toLowerCase())) {
        setSnackbar({
          open: true,
          severity: "info",
          message: "Scholar Address Already Exist!",
        });
        setLoading(false);
        return;
      }
      const sigAndKey = await getSigAndKey(values.scholarAddress);
      console.log("sigAndKey", sigAndKey);
      if (sigAndKey) {
        setLoading(true);
        console.log("values again", values);
        const body = {
          scholarAddress: values.scholarAddress.toLowerCase(),
          scholarName: values.scholarName,
          guildId: connectedAccount._id,
        };
        console.log("body", body);
        // addscholar api
        const resp = await fetchApi(
          `${SERVER_BASE_URL_PROD}/registration/addScholar`,
          body,
          "post"
        );
        console.log("resp", resp);
        if (resp.status === 201) {
          const updatedScholars = [
            ...scholars,
            {
              ...resp.payload,
              coverPic: dummyScholarCover,
              profilePic: dummyScholarProfile,
            },
          ];

          console.log("updatedScholars", updatedScholars);

          await addScholar(updatedScholars);

          resetAndClose();
          setLoading(false);
        } else {
          setSnackbar({
            open: true,
            severity: "error",
            message: "Scholar Already Exist!",
          });
          setLoading(false);
        }
      } else {
        setSnackbar({
          open: true,
          severity: "error",
          message: "No such rental account exists. Please try again.",
        });
        setLoading(false);
      }
    },
  });

  const resetAndClose = () => {
    setOpen(false);
    formik.resetForm();
  };

  console.log("formik values", formik.values);

  const NftBoxProps = () => {
    if (downMd && !collapsed) {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(10, 1fr)",

        gap: "30px",
      };
    } else if (downMd) {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(15, 1fr)",
        gap: "30px",
      };
    } else if (downXl && !collapsed) {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(15, 1fr)",
        gap: "30px",
      };
    } else if (downXl || !collapsed) {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(20, 1fr)",
        gap: "30px",
      };
    } else {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(25, 1fr)",
        gap: "30px",
      };
    }
  };

  const profileNftsFromRedux = useTypedSelector(
    (state) => state.apiReducer.profileNfts
  );
  const [profileNfts, setProfileNfts] = useState(
    profileNftsFromRedux.map((nft) => {
      return { ...nft, selected: false };
    })
  );
  const [type, setType] = useState("ERC721");

  const [currentInstance, setCurrentInstance] = useState(0);

  const instanceEntity = {
    scholarAddress: "",
    rewardTokenAddress: "",
    split: "",
    amount: "",
    droppedNfts: [],
  };

  const instanceGenerator = () => {
    return instanceEntity;
  };

  const [instances, setInstances] = useState([instanceEntity]);

  const addInstance = () => {
    setInstances([...instances, instanceGenerator()]);
  };

  const updateInstance = (index, payload) => {
    let copy = [...instances];
    copy[index] = {
      ...copy[index],
      ...payload,
    };
    setInstances(copy);
  };

  const removeInstance = (index) => {
    let copy = [...instances];
    copy.splice(index, 1);
    setInstances(copy);
  };

  const [operation, setOperation] = useState("bulk-lend");
  const [droppedNfts, setDroppedNfts] = useState([]);
  const [scholarAddress, setScholarAddress] = useState("");
  const [split, setSplit] = useState("");
  const [selectedNft, setSelectedNft] = useState(
    profileNfts.filter((nftP) => nftP.selected)
  );

  useEffect(() => {
    setProfileNfts(
      profileNftsFromRedux.map((nft) => {
        return { ...nft, selected: false };
      })
    );
  }, [JSON.stringify(profileNftsFromRedux)]);

  useEffect(() => {
    setSelectedNft(profileNfts.filter((nft) => nft.selected));
    setType(profileNfts.filter((nft) => nft.selected)[0]?.contractType);
  }, [profileNfts]);

  if (step === 1) {
    return (
      <SelectedNftStep
        selectedNft={profileNfts}
        setSelectedNft={setSelectedNft}
        setProfileNfts={setProfileNfts}
        setStep={setStep}
        operation={operation}
        droppedNfts={droppedNfts}
        setDroppedNfts={setDroppedNfts}
        scholarAddress={scholarAddress}
        setScholarAddress={setScholarAddress}
        split={split}
        setSplit={setSplit}
        currentInstance={currentInstance}
        setCurrentInstance={setCurrentInstance}
        instances={instances}
        addInstance={addInstance}
        updateInstance={updateInstance}
        removeInstance={removeInstance}
        setInstances={setInstances}
        type={type}
      />
    );
  }

  console.log("profileNfts in curr", profileNfts);

  return (
    <ProfileLayout
      FilterBox={() => (
        <FilterBox collapsed={collapsed} setCollapsed={setCollapsed} />
      )}
      layoutType={LAYOUT_TYPES.GUILD_HUB}
      currView={currView}
      setCurrView={(view) => {
        setCurrView(view);
        setSearchShow(false);
        setSearchVar("");
      }}
      // setSearchShow={setSearchShow}
      // setSearchVar={setSearchVar}
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          paddingBottom: "20px",
        }}
        gap="10px"
      >
        <Stack
          direction={"row"}
          justifyContent="flex-start"
          gap="20px"
          sx={{
            marginBottom: "25px",
            width: "100%",
            paddingTop: "16px",
            paddingLeft: "16px",
          }}
        >
          <Box
            display="flex"
            backgroundColor={theme.palette.secondary.dark}
            borderRadius="3px"
            flex={8}
          >
            <IconButton type="button" sx={{ p: 1 }}>
              <img src={searchIcon} alt="search" />
            </IconButton>
            <InputBase
              sx={{ ml: 2, flex: 1, fontSize: "14px" }}
              placeholder={
                currView === "scholar-details"
                  ? "Search By Scholar"
                  : "Search By NFT Name"
              }
              value={searchVar}
              onChange={(e) => {
                const { value } = e.target;
                setSearchVar(value);
                if (value === "") {
                  setSearchShow(false);
                  setFiltered([]);
                } else {
                  const filteredArr =
                    currView === "scholar-details"
                      ? scholarsToRender.filter((scholar) =>
                          scholar.scholarName
                            .toLowerCase()
                            .includes(value.toLowerCase())
                        )
                      : profileNfts.filter((nft) =>
                          nft?.name?.toLowerCase().includes(value.toLowerCase())
                        );

                  setFiltered(filteredArr);
                  setSearchShow(true);
                }
              }}
            />
          </Box>

          <Box
            display="flex"
            backgroundColor={theme.palette.secondary.dark}
            borderRadius="3px"
            flex={1}
          >
            <img
              src={view === "gallery" ? galleryViewActive : galleryView}
              alt="gallery"
              onClick={() => setView("gallery")}
            />
            <img
              src={view === "table" ? tableViewActive : tableView}
              alt="table"
              onClick={() => setView("table")}
              style={{ marginLeft: 10 }}
            />
          </Box>
        </Stack>

        {currView === "asset-details" && (
          <AssetDetails
            view={view}
            NftBoxProps={NftBoxProps}
            profileNfts={profileNfts}
            setProfileNfts={setProfileNfts}
            setStep={setStep}
            searchVar={searchVar}
            searchShow={searchShow}
            filtered={filtered}
            setFiltered={setFiltered}
          />
        )}

        {currView === "scholar-details" && (
          <ScholarDetails
            view={view}
            NftBoxProps={NftBoxProps}
            setOpen={setOpen}
            scholarsToRender={scholarsToRender}
            searchShow={searchShow}
            filtered={filtered}
          />
        )}
      </Box>
      <CustomModal
        open={open}
        onClose={resetAndClose}
        modalFunc={() => setOpen(false)}
        Children={AddScholarForm}
        childrenProps={{
          onClose: resetAndClose,
          formik,
        }}
        width={"1000px"}
        height={"350px"}
      />
    </ProfileLayout>
  );
};

export default Profile;
